export enum SwitchEntityTypes {
  Flow = "flow",
  Asset = "asset",
  Pdf = "PDF",
  EmbeddedVideo = "embedded video",
  Survey = "survey",
  Link = "link",
  Scorm = "scorm",
  Empty = "",
}
